
<router-outlet></router-outlet>

 
